/**
 * Created by rhinov15 on 16/09/2016.
 */

import { Entity, Events, eventsManager, math, SceneConstants } from "@rhinov/savane-js";
import { ActionState, ActionStateEnum, IdleVisualiseState } from "..";
import { PlanManager } from "../../../../cocosPlan";



export class RoomsValidationState extends IdleVisualiseState {

    state: number = ActionStateEnum.RoomsValidation;
    constructor() {
        super();
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (hoverEntities !== null && hoverEntities.length > 0) {
            var entity = hoverEntities[0];
            if (entity.entityType === SceneConstants.EntityType.Room) {
                PlanManager.getInstance().updateItemsSelected([entity], true);
            }
            else {
                PlanManager.getInstance().updateItemsSelected([entity], true, false);
            }
        }
        else {
            eventsManager.instance.dispatch(Events.HIDE_TULIP);
        }

        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);
        return null;
    }
}
